import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import Form from 'react-bootstrap/Form';
import Button from "react-bootstrap/Button";
import FloatingLabel from 'react-bootstrap/FloatingLabel';


export const Email = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
        const btn = document.getElementById('btn');

        const serviceID = process.env.service_l9mwuil;
        const templateID = process.env.template_mxc866k;
        const userID = process.env.BaQpd23w3Sd6itBoQ;

        emailjs.sendForm('service_l9mwuil', 'template_mxc866k', form.current, 'BaQpd23w3Sd6itBoQ')
            .then((result) => {

                //resetting values after email sent
                // const btn = document.getElementById('btn');
                btn.addEventListener('click', function handleClick(event) {

                    console.log("clicked")
                    event.preventDefault();
                    const firstname = document.getElementById('fname');
                    const secondname = document.getElementById('sname');
                    const email = document.getElementById('email');
                    const message = document.getElementById('message');
                    alert("Your Response has been sent");

                    firstname.value = '';
                    secondname.value = '';
                    email.value = '';
                    message.value = '';
                });
            }
                , (error) => {
                    console.log(error.text);
                });
    };


    return (

        <Form ref={form} onSubmit={sendEmail}>
            <Form.Group className="mb-3" controlId="formBasicname">
                <Form.Label>First Name</Form.Label>
                <Form.Control type="text" placeholder="Your First Name" name="fname" id="fname" />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicname">
                <Form.Label>Last Name</Form.Label>
                <Form.Control type="text" placeholder="Your Last Name" name="sname" id="sname" />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Your Email address</Form.Label>
                <Form.Control type="email" placeholder="Enter email" name="email" id="email" />
                <Form.Text className="text-muted">
                    We'll never share your email with anyone else.
                </Form.Text>
            </Form.Group>

            <Form.Label>Your Message</Form.Label>
            <FloatingLabel controlId="floatingTextarea2" label="Comments" placeholder="Leave a comment here..">
                <Form.Control
                    id="message"
                    name="message"
                    as="textarea"
                    type="text"
                    placeholder="Leave a comment here.."
                    style={{ height: '100px' }}
                />
            </FloatingLabel>
            <br />

            <Button variant="primary" type="submit" value="send" id="btn">
                Submit
            </Button>

        </Form>

    );
};

export default Email;



